import React from "react";

import { useIntl } from "react-intl";

import todayOrYesterday from "Libs/datetime";
import { autoFormatBytes } from "Libs/utils";

import ActivityTooltip from "../components/activities/Tooltip";
import RoundLegend from "../components/RoundLegend";
import Tooltip from "../components/tooltip";
import {
  DateTime,
  Flex,
  Table,
  TableRow,
  Td
} from "../components/tooltip/style";
import { useHttpMetricsContext } from "../context";
import { formatPercent } from "../helper";
import { findMetricsValue } from "../impact/util";
import { CursorDataSyncType, HttpMetricsType } from "../types";

import { BandWidthSeries } from "./type";
import { bandwidthColorBand } from "./utils";

type TooltipContentProps = {
  cursorSync?: CursorDataSyncType<HttpMetricsType>;
  series: BandWidthSeries[];
};

const TooltipContent = (props: TooltipContentProps) => {
  const intl = useIntl();

  const { adaptedCursor, chartRect } = props.cursorSync || {};
  const {
    absoluteY,
    absoluteX,
    activityId,
    xInvert,
    indexedData,
    isInCursorGroup
  } = adaptedCursor || {};

  const activities = useHttpMetricsContext()?.activities;
  const activity = activityId
    ? activities?.find(act => act.id === activityId)
    : null;

  const requestBytes = findMetricsValue(indexedData, "request.bytes")?.sum || 0;
  const responseBytes =
    findMetricsValue(indexedData, "response.bytes")?.sum || 0;
  const totalByte =
    findMetricsValue(indexedData, "bandwidth.total.bytes")?.sum || 0;

  return (
    <Tooltip
      chartRect={chartRect}
      isVisible={isInCursorGroup}
      x={absoluteX}
      y={absoluteY}
    >
      <Table>
        <tbody>
          <TableRow>
            <DateTime colSpan={3}>{todayOrYesterday(xInvert)}</DateTime>
          </TableRow>
          <TableRow isActive={true}>
            <Td>{autoFormatBytes(totalByte)}</Td>
            <Td bold colSpan={2}>
              {intl.formatMessage({ id: "total" })}
            </Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={bandwidthColorBand.request} />
                <span className="bold">
                  {formatPercent(requestBytes, totalByte)}
                </span>
              </Flex>
            </Td>
            <Td>{autoFormatBytes(requestBytes)}</Td>
            <Td> {intl.formatMessage({ id: "incoming" })}</Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={bandwidthColorBand.response} />
                <span className="bold">
                  {formatPercent(responseBytes, totalByte)}
                </span>
              </Flex>
            </Td>
            <Td>{autoFormatBytes(responseBytes)}</Td>
            <Td>{intl.formatMessage({ id: "outgoing" })}</Td>
          </TableRow>
          {activity && (
            <TableRow isActive={true}>
              <Td colSpan={3}>
                <ActivityTooltip activity={activity} />
              </Td>
            </TableRow>
          )}
        </tbody>
      </Table>
    </Tooltip>
  );
};

export default TooltipContent;
